import { UsageTrackingTable } from "@/components/usage/UsageTrackingTable";
import { Plan } from "@/types/supabase";

interface CurrentPlanUsageTabProps {
  currentPlan: Plan;
  organization: any;
}

export const CurrentPlanUsageTab = ({
  currentPlan,
  organization,
}: CurrentPlanUsageTabProps) => {
  return (
    <div className="max-w-6xl mx-auto">
      <UsageTrackingTable
        currentPlan={currentPlan}
        organization={organization}
      />
    </div>
  );
};

export default CurrentPlanUsageTab;
